export const iconFontAwesomeDesignBezierCurve = (
	<i className="fa-solid fa-bezier-curve"></i>
);
